// src/utils/swalConfirm.js
import Swal from "sweetalert2";

export const handleDeleteWithConfirm = async ({
  title,
  text,
  icon = "warning",
  confirmButtonText = "Yes, delete it!",
  confirmCallback,
}) => {
  const result = await Swal.fire({
    title: title || "Are you sure?",
    text: text || "You won't be able to revert this!",
    icon,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText,
  });

  if (result.isConfirmed && typeof confirmCallback === "function") {
    confirmCallback();
  }
};

export const contact_details = async ({
  title,
  text,
  icon,
  confirmButtonText,
  confirmCallback,
}) => {
  const result = await Swal.fire({
    title: title || "",
    text: text || "",
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirmButtonText,
  });

  if (result.isConfirmed && typeof confirmCallback === "function") {
    confirmCallback();
  }
};

export const Client_View = async ({
  title,
  text,
  icon,
  confirmButtonText,
  denyButtonText,
  confirmCallback,
  denyCallback,
  cancleCallback,
}) => {
  const result = await Swal.fire({
    title: title || "",
    text: text || "",
    icon: icon,
    showCancelButton: true,
    showDenyButton: !!denyCallback,
    confirmButtonColor: "#d33",
    denyButtonColor: "#111827",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirmButtonText || "Confirm",
    denyButtonText: denyButtonText || "Add Prospect",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed && typeof confirmCallback === "function") {
    confirmCallback();
  } else if (result.isDenied && typeof denyCallback === "function") {
    denyCallback();
  } else if (
    result.dismiss === Swal.DismissReason.cancel &&
    typeof cancleCallback === "function"
  ) {
    cancleCallback();
  }
};
